const RouteMap = {
  slots: "slots",
  liveCasino: "live-casino",
  sports: "sports",
  lottery: "lottery",
  download: "download",
  help: "help",
  login: "login",
  register: "register",
  shareholder: "shareholder",
  promotions: "promotions",
};
export default RouteMap;
